import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterByAddress',
})
export class FilterByAddressPipe implements PipeTransform {
  transform(value: any, selectedAddress: any): any {
    if (selectedAddress === undefined || selectedAddress === '0') {
      return value;
    }

    if (selectedAddress === 'noaddress') {
      return value.filter((v) => !v.addressKey);
    }

    return value.filter((v) => v.addressKey === selectedAddress);
  }
}
